import { useState } from 'react';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50 to-background-100/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5 animate-fade-in">
              <i className="ri-fire-line"></i>
              <span>实时更新 · 安全访问 · 全网首发</span>
            </div>

            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-3 animate-fade-in-up">
              51吃瓜黑料网 | 全网最新娱乐八卦一手掌握
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-4 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              你身边的吃瓜第一站，热门黑料、明星八卦、网曝猛料一网打尽
            </p>

            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0 animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
              51吃瓜黑料网是国内领先的娱乐八卦资讯聚合平台，专注于为中文互联网用户提供最新、最全、最真实的娱乐黑料与明星八卦。
              我们聚合全网100+信息源，7×24小时不间断更新，从综艺内幕到网红翻车，从影视圈潜规则到直播带货乱象，
              每天超过200条新鲜猛料持续输出，确保你永远站在吃瓜第一线。当前全站热门专题覆盖明星塌房、综艺黑幕、
              网红翻车、饭圈大战等多个板块，51吃瓜网站入口一键直达，安全访问无需注册。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                <span className="text-sm text-foreground-700">
                  <strong className="text-primary-600">每日更新200+条</strong> 新鲜猛料
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-700">
                  覆盖<strong className="text-accent-600">全网100+信源</strong>
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-sm text-foreground-700">
                  <strong className="text-primary-600">7×24小时</strong> 不间断更新
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-in-up" style={{ animationDelay: '0.25s' }}>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-bar-chart-line"></i>
                查看榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none animate-slide-in-right">
            {!imgError ? (
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20media%20composition%20with%20warm%20coral%20red%20and%20amber%20gradients%2C%20flowing%20geometric%20shapes%20resembling%20data%20streams%20and%20news%20waves%2C%20editorial%20magazine%20cover%20style%2C%20clean%20sophisticated%20design%2C%20soft%20dramatic%20lighting%2C%20cinematic%20mood%2C%20dark%20elegant%20accents%2C%20minimalist%20yet%20dynamic%20composition%2C%20entertainment%20and%20media%20theme&width=1400&height=1050&seq=hero-visual-main&orientation=landscape"
                  alt="51吃瓜黑料网 娱乐八卦资讯聚合平台主视觉"
                  className="w-full h-full object-cover object-top"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-black/15 via-transparent to-transparent"></div>
              </div>
            ) : (
              <div className="relative w-full aspect-[4/3] rounded-2xl bg-background-200 flex items-center justify-center">
                <i className="ri-image-line text-5xl text-background-400"></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}